<template>
    <div
        class="modal_header"
        :class="[classes, border && 'border-b border-gray-100']"
    >
        <button type="button" @click="onCloseHeader" class="flex mr-4">
            <!-- <fa :icon="['fal', 'xmark']"></fa> -->
            <fa :icon="['fal', iconShape]" />
        </button>
        <h4 v-if="headingText && !headingIcon">
            {{ headingText }}
        </h4>
        <h4 v-if="headingText && headingIcon" class="flex items-center">
            <div
                class="warp_icon w-8 h-8 flex items-center justify-center mr-1"
            >
                <span
                    class="absolute top-0 left-0 z-0 h-full w-full opacity-30 rounded-full"
                    :style="`background:${modalIconColor}`"
                >
                </span>
                <div
                    class="w-6 h-6 flex items-center justify-center rounded-full z-30"
                    :style="`background:${modalIconColor}`"
                >
                    <fa
                        :icon="[headingIconType, headingIcon]"
                        class="!text-white z-10 !text-xs m-auto"
                    />
                </div>
            </div>
            {{ headingText }}
        </h4>

        <slot name="modalHeaderLeft"></slot>
        <slot name="modalHeaderRight"></slot>
    </div>
</template>

<script setup>
/* Composables imports */
import useToggleModal from "@/composables/useToggleModal";
const { toggleModal } = useToggleModal();
/* Composables imports */

/* Pinia imports */
import { useHeaderStore } from "@/stores/headerStore.js";
const headerStore = useHeaderStore();
/* Pinia imports */

const emit = defineEmits(["onHeaderToggle"]);

const props = defineProps({
    headingText: {
        type: String,
        default: "",
    },
    headingIconType: {
        type: String,
        default: 'fal',
    },
    headingIcon: {
        type: String,
        default: "",
    },
    modalIconColor: {
        type: String,
        default: "",
    },
    classes: {
        type: String,
    },
    directClose: {
        type: Boolean,
    },
    border: {
        type: Boolean,
        default: false,
    },
    iconShape: {
        type: String,
        default: 'xmark',
    }
});

const onHeaderToggle = () => {
    props.directClose ? toggleModal() : false;
};

const onCloseHeader = () => {
    onHeaderToggle();
    emit("onHeaderToggle");
    headerStore.setBoardFormName("");
};
</script>

<style scoped>
.modal_header {
    @apply flex items-center sm:px-6 px-4 sm:py-6 py-4 static top-0 bg-white dark:bg-black-500 left-0 right-0 z-50;
}

svg {
    @apply text-gray-200 text-2xl leading-6 dark:text-gray-500 w-[18px];
}

.modal_header h4 {
    @apply text-black-600 dark:text-white text-lg font-semibold mr-auto leading-6;
}
</style>
